export default {
  getAll: {
    url: '/api/account/getAll',
    method: 'get'
  },
  create: {
    url: '/api/account/create',
    method: 'post'
  },
  update: {
    url: '/api/account/update',
    method: 'put'
  },
  delete: {
    url: '/api/account/delete',
    method: 'delete'
  },
  getCompanyAccount: {
    url: '/api/account/getCompanyAccount',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/account.js